module.exports = __webpack_public_path__ + "static/img/4.fc8cd82.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/img/4.png
// module id = C6fQ
// module chunks = 0